let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1I00e")).then(() => parcelRequire('dyLwU'));